import { Stack, Typography, Collapse } from "@mui/material"
import { ReactElement, memo } from "react"

import AppChip from "../dataDisplay/chips/appChip"
import AppPaper from "../surfaces/appPaper"

type TSelectedFilterTabProps = {
    name: string
    value: string | number | undefined | null
    onDelete: () => void
    show?: boolean
}

/**
 * Displays selected filter to user via tab at top of desktop webpage.
 */
const SelectedFilterTab = ({
    name,
    value,
    onDelete,
    show,
}: TSelectedFilterTabProps): ReactElement => (
    <Collapse in={show !== undefined ? show : !!value} orientation="horizontal">
        <AppPaper sx={{ p: 1.5 }}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography fontWeight="bold">{name}</Typography>
                <AppChip
                    clickable
                    color="secondary"
                    variant="filled"
                    label={value}
                    onDelete={onDelete}
                />
            </Stack>
        </AppPaper>
    </Collapse>
)

SelectedFilterTab.defaultProps = {
    show: undefined,
}

export default memo(SelectedFilterTab)
